(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-bundle-section"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initBundleSection(sectionEl) {
      if (!sectionEl) return;

      var items = Array.prototype.slice.call(
        sectionEl.querySelectorAll('[data-bundle-item]')
      );
      if (!items.length) return;

      var countEl = sectionEl.querySelector('[data-bundle-count]');
      var priceEl = sectionEl.querySelector('[data-bundle-price]');
      var savingWrapper = sectionEl.querySelector('[data-bundle-saving-wrapper]');
      var savingEl = sectionEl.querySelector('[data-bundle-saving]');
      var addBtn = sectionEl.querySelector('[data-bundle-add]');
      var btnTextEl = sectionEl.querySelector('.cyl-bundle-summary__button-text');
      var summaryEl = sectionEl.querySelector('[data-bundle-summary]');
      var shouldRedirect = sectionEl.getAttribute('data-redirect-to-cart') === 'true';
      var originalButtonLabel = btnTextEl ? btnTextEl.textContent.trim() : '';
      var prefixEl = sectionEl.querySelector('[data-bundle-prefix]');
      var wordEl   = sectionEl.querySelector('[data-bundle-word]');
      var suffixEl = sectionEl.querySelector('[data-bundle-suffix]');

      if (!countEl || !priceEl) return;

      var currentDisplayedPrice = 0;
      var currentDisplayedSaving = 0;
      var priceAnimationId = null;
      var savingAnimationId = null;

      var moneyFormat = sectionEl.getAttribute('data-money-format') || '{{amount_with_comma_separator}} \u20AC';

      function formatMoney(cents) {
        if (typeof cents !== 'number') cents = 0;
        var value = (Math.abs(cents) / 100).toFixed(2);
        var parts = value.split('.');
        var dollars = parts[0];
        var decimals = parts[1];

        function addSep(str, sep) {
          return str.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        }

        return moneyFormat
          .replace('{{amount_with_comma_separator}}', addSep(dollars, '.') + ',' + decimals)
          .replace('{{amount_no_decimals_with_comma_separator}}', addSep(dollars, '.'))
          .replace('{{amount_with_apostrophe_separator}}', addSep(dollars, "'") + '.' + decimals)
          .replace('{{amount_no_decimals_with_space_separator}}', addSep(dollars, ' '))
          .replace('{{amount_no_decimals}}', addSep(dollars, ','))
          .replace('{{amount}}', addSep(dollars, ',') + '.' + decimals);
      }

      function animateValue(el, startVal, endVal, duration, formatter, animIdKey) {
        if (animIdKey === 'price' && priceAnimationId) {
          cancelAnimationFrame(priceAnimationId);
        }
        if (animIdKey === 'saving' && savingAnimationId) {
          cancelAnimationFrame(savingAnimationId);
        }

        if (startVal === endVal) {
          el.textContent = formatter(endVal);
          return;
        }

        var startTime = null;
        var dur = duration || 300;

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / dur, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = Math.round(startVal + (endVal - startVal) * eased);
          el.textContent = formatter(current);

          if (progress < 1) {
            var id = requestAnimationFrame(step);
            if (animIdKey === 'price') priceAnimationId = id;
            if (animIdKey === 'saving') savingAnimationId = id;
          } else {
            el.textContent = formatter(endVal);
          }
        }

        var id = requestAnimationFrame(step);
        if (animIdKey === 'price') priceAnimationId = id;
        if (animIdKey === 'saving') savingAnimationId = id;
      }

      function pulsePriceEl() {
        priceEl.classList.remove('cyl-bundle-summary__price--pulse');
        void priceEl.offsetWidth;
        priceEl.classList.add('cyl-bundle-summary__price--pulse');
      }

      function updateCheckedStates() {
        items.forEach(function(item) {
          var checkbox = item.querySelector('.cyl-bundle-item__checkbox-input');
          if (checkbox && checkbox.checked) {
            item.classList.add('cyl-bundle-item--checked');
          } else {
            item.classList.remove('cyl-bundle-item--checked');
          }
        });
      }

      function updateSummary() {
        var totalPrice = 0;
        var totalCompare = 0;
        var count = 0;

        items.forEach(function(item) {
          var checkbox = item.querySelector('.cyl-bundle-item__checkbox-input');
          if (!checkbox || !checkbox.checked) return;

          var price = parseInt(item.getAttribute('data-price'), 10) || 0;
          var compare = parseInt(item.getAttribute('data-compare-price'), 10) || price;

          count += 1;
          totalPrice += price;
          totalCompare += compare;
        });

        updateCheckedStates();

        if (countEl) {
          countEl.textContent = count > 0 ? count : '';
        }

        animateValue(priceEl, currentDisplayedPrice, totalPrice, 300, formatMoney, 'price');
        if (totalPrice === 0) {
          priceEl.textContent = '\u2013';
          priceEl.classList.add('cyl-bundle-summary__price--empty');
        } else {
          priceEl.classList.remove('cyl-bundle-summary__price--empty');
          pulsePriceEl();
        }
        currentDisplayedPrice = totalPrice;

        if (savingWrapper && savingEl) {
          var saving = totalCompare - totalPrice;

          if (saving > 0) {
            animateValue(savingEl, currentDisplayedSaving, saving, 300, formatMoney, 'saving');
            currentDisplayedSaving = saving;
            savingWrapper.classList.remove('cyl-bundle-summary__saving--hidden');
          } else {
            currentDisplayedSaving = 0;
            savingWrapper.classList.add('cyl-bundle-summary__saving--hidden');
          }
        }

        if (prefixEl && wordEl && suffixEl) {
          if (count === 0) {
            countEl.textContent  = '';
            prefixEl.textContent = 'W\u00E4hle mindestens ein Produkt';
            wordEl.textContent   = '';
            suffixEl.textContent = '';
          } else if (count === 1) {
            countEl.textContent  = '';
            prefixEl.textContent = 'F\u00FCr dich';
            wordEl.textContent   = 'dieses Produkt';
            suffixEl.textContent = 'f\u00FCr nur';
          } else {
            countEl.textContent  = count;
            prefixEl.textContent = 'F\u00FCr dich alle';
            wordEl.textContent   = 'Produkte';
            suffixEl.textContent = 'f\u00FCr nur';
          }
        }

        if (addBtn && btnTextEl) {
          if (count === 0) {
            addBtn.disabled = true;
            addBtn.classList.add('cyl-bundle-summary__button--disabled');
            btnTextEl.textContent = 'Bitte mindestens 1 Artikel w\u00E4hlen';
          } else {
            addBtn.disabled = false;
            addBtn.classList.remove('cyl-bundle-summary__button--disabled');
            btnTextEl.textContent = originalButtonLabel;
          }
        }
      }

      function setButtonState(state, text, duration) {
        if (!addBtn || !btnTextEl) return;

        addBtn.classList.remove(
          'cyl-bundle-summary__button--loading',
          'cyl-bundle-summary__button--success',
          'cyl-bundle-summary__button--error',
          'cyl-bundle-summary__button--disabled'
        );

        if (state === 'loading') {
          addBtn.classList.add('cyl-bundle-summary__button--loading');
          btnTextEl.textContent = text || 'Wird hinzugef\u00FCgt\u2026';
        } else if (state === 'success') {
          addBtn.classList.add('cyl-bundle-summary__button--success');
          btnTextEl.textContent = text || 'Hinzugef\u00FCgt \u2713';
          if (summaryEl) summaryEl.classList.add('cyl-bundle-summary--glow');
        } else if (state === 'error') {
          addBtn.classList.add('cyl-bundle-summary__button--error');
          btnTextEl.textContent = text || 'Fehler \u2013 bitte erneut versuchen';
        }

        if (duration && state !== 'loading') {
          setTimeout(function() {
            addBtn.classList.remove(
              'cyl-bundle-summary__button--success',
              'cyl-bundle-summary__button--error'
            );
            if (summaryEl) summaryEl.classList.remove('cyl-bundle-summary--glow');
            btnTextEl.textContent = originalButtonLabel;
            addBtn.disabled = false;
          }, duration);
        }
      }

      sectionEl.addEventListener('change', function(event) {
        if (event.target.matches('.cyl-bundle-item__checkbox-input')) {
          updateSummary();
          updateToggleAllText();
        }
      });

      // Card click toggles checkbox
      items.forEach(function(item) {
        if (item.getAttribute('data-available') === 'false') return;
        item.style.cursor = 'pointer';
        item.addEventListener('click', function(e) {
          if (e.target.closest('a') || e.target.closest('input') || e.target.closest('label')) return;
          var checkbox = item.querySelector('.cyl-bundle-item__checkbox-input');
          if (checkbox && !checkbox.disabled) {
            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      // Toggle All
      var toggleAllBtn = sectionEl.querySelector('[data-bundle-toggle-all]');

      function updateToggleAllText() {
        if (!toggleAllBtn) return;
        var availableItems = items.filter(function(item) {
          return item.getAttribute('data-available') !== 'false';
        });
        if (availableItems.length === 0) {
          toggleAllBtn.style.display = 'none';
          return;
        }
        toggleAllBtn.style.display = '';
        var allChecked = availableItems.every(function(item) {
          var cb = item.querySelector('.cyl-bundle-item__checkbox-input');
          return cb && cb.checked;
        });
        toggleAllBtn.textContent = allChecked ? 'Alle abw\u00E4hlen' : 'Alle ausw\u00E4hlen';
      }

      if (toggleAllBtn) {
        toggleAllBtn.addEventListener('click', function() {
          var availableItems = items.filter(function(item) {
            return item.getAttribute('data-available') !== 'false';
          });
          var allChecked = availableItems.every(function(item) {
            var cb = item.querySelector('.cyl-bundle-item__checkbox-input');
            return cb && cb.checked;
          });
          availableItems.forEach(function(item) {
            var cb = item.querySelector('.cyl-bundle-item__checkbox-input');
            if (cb) cb.checked = !allChecked;
          });
          updateSummary();
          updateToggleAllText();
        });
      }

      if (addBtn) {
        addBtn.addEventListener('click', function() {
          if (addBtn.disabled) return;

          var payloadItems = [];

          items.forEach(function(item) {
            var checkbox = item.querySelector('.cyl-bundle-item__checkbox-input');
            if (!checkbox || !checkbox.checked) return;

            var variantId = item.getAttribute('data-variant-id');
            if (!variantId) return;

            payloadItems.push({
              id: parseInt(variantId, 10),
              quantity: 1
            });
          });

          if (!payloadItems.length) return;

          setButtonState('loading');

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: payloadItems })
          })
          .then(function(response) {
            if (!response.ok) throw new Error('Network error');
            return response.json();
          })
          .then(function() {
            setButtonState('success', null, 2500);

            if (shouldRedirect) {
              setTimeout(function() {
                window.location.href = '/cart';
              }, 800);
            } else {
              var cartUpdateDetail = { data: {} };

              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: cartUpdateDetail
                })
              );

              ['cart:update', 'cart:change', 'cart:refresh'].forEach(function(eventName) {
                document.dispatchEvent(
                  new CustomEvent(eventName, {
                    detail: cartUpdateDetail
                  })
                );
              });

              setTimeout(function() {
                var drawer = document.querySelector('cart-drawer-component');
                if (drawer && typeof drawer.open === 'function') {
                  drawer.open();
                }
              }, 600);
            }
          })
          .catch(function() {
            setButtonState('error', null, 3000);
          });
        });
      }

      var initialPrice = 0;
      var initialSaving = 0;
      items.forEach(function(item) {
        var checkbox = item.querySelector('.cyl-bundle-item__checkbox-input');
        if (checkbox && checkbox.checked) {
          initialPrice += parseInt(item.getAttribute('data-price'), 10) || 0;
          var compare = parseInt(item.getAttribute('data-compare-price'), 10) || 0;
          initialSaving += compare;
        }
      });
      currentDisplayedPrice = initialPrice;
      currentDisplayedSaving = Math.max(0, initialSaving - initialPrice);

      updateCheckedStates();
      updateSummary();
      updateToggleAllText();

      // Entrance animation
      var animatables = items.slice();
      if (summaryEl) animatables.push(summaryEl);
      animatables.forEach(function(el) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(16px)';
      });
      requestAnimationFrame(function() {
        animatables.forEach(function(el, i) {
          setTimeout(function() {
            el.style.opacity = '';
            el.style.transform = '';
          }, i * 80);
        });
      });
    }

    function initAllBundleSections(root) {
      var scope = root || document;
      var sections = Array.prototype.slice.call(
        scope.querySelectorAll('[data-bundle-section]')
      );

      sections.forEach(initBundleSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initAllBundleSections(document);
      });
    } else {
      initAllBundleSections(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
      initAllBundleSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
